import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import {
  getAutheriseOptions,
  getCategorys,
  getCompanys,
  getDepartments,
  getDesignation,
  getdutywithdate,
  getEmployee,
  getGroup,
  getProfitCenter,
  getRecordsForAutherise,
  getShift,
  InsertDuty,
  ProcessEmpLeaveALL,
  UpdateAutheriseLeavetoLeave,
  UpdateLeaveandInsertRecord,
  UpdaterecordandInsertRecord,
  UpdateRecordsandleaveFromAutherise,
  UpdateRecordsFromAutherise,
} from "../../services/dataService";
import toast from "react-hot-toast";
import Breadcrumb from "../../components/common/Breadcrumb";
import { IconChevronDown } from "@tabler/icons-react";
import Loading from "../../components/common/Loading";
import jsPDF from "jspdf";
import "jspdf-autotable";

function Autherise() {
  const UID = localStorage.getItem("userId");
  const isAdmin = localStorage.getItem("IsAdmin");
  const departmentIds = localStorage.getItem("DepartmentId") || "";
  const DepId = departmentIds.split(",")[0] || null;
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchTermtable, setSearchTermtable] = useState("");
  const [filterMethod, setFilterMethod] = useState("");
  const [moadaopenClr, setModalOpenClr] = useState(false);
  const [employeeDetails, setEmployeeDetails] = useState([]);
  const [dutyData, setDutyData] = useState([]);
  const [moadaopen, setModalOpen] = useState(false);
  const [dates, setDates] = useState([]);
  const [fromDate, setFromDate] = useState();
  const [toDate, setToDate] = useState("");
  const [loading, setLoading] = useState(false);
  const [shiftData, setShiftData] = useState([]);
  const [shiftemployeedata, setShiftEmployeeData] = useState([]);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const dropdownRef = useRef(null);
  const [RecordData, setRecordData] = useState([]);
  const [options, setOptions] = useState("");
  const [category, setCategory] = useState([]);
  const [group, setGroup] = useState([]);
  const [FilterProfitcenter, setFilterProfitcenter] = useState([]);
  const [dropdownOptions, setDropdownOptions] = useState([]);
  const [editCategoryModal, setEditCategoryModal] = useState(false);
  const [Department, setDepartment] = useState([]);
  const [temp, setTemp] = useState([]);
  const [dataFilter, setDataFilter] = useState([]);
  const [selectedMethodName, setselectedMethodName] = useState([]);
  const [companyDetails, setCompanyDetails] = useState([]);
  const [designation, setdesignation] = useState([]);
  const [selectedOptionId, setselectedOptionId] = useState();
  const [addCategoryModal, setAddCategoryModal] = useState(false);
  const [selectedDuty, setSelectedDuty] = useState({
    Id: "",
    EmpId: "",
    ShiftId: "",
    DepartmentId: DepId,
    DateValue: "",
    Remarks: "",
    AddedBy: UID,
    ToDate: "",
  });

  const fetchCompanyDetails = async () => {
    try {
      const response = await getCompanys(UID);
      setCompanyDetails(response.data.data[0]);
    } catch (error) {
      console.error("An error occurred:", error);
      toast.error("An error occurred while fetching company details");
    }
  };

  const generatePDF = (selectedMethodName) => {
    // Initialize PDF with professional settings
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a3",
    });

    // Page dimensions
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    // Enhanced margins and layout guides
    const margins = {
      left: 15,
      right: 15,
      top: 25,
      bottom: 25,
      gutter: 10,
    };

    // Content area calculations
    const contentWidth = pageWidth - margins.left - margins.right;
    const contentHeight = pageHeight - margins.top - margins.bottom;

    // Color mapping function for single-color cases
    const getDutyColor = (duty) => {
      if (!duty) return [255, 255, 255]; // White for no duty

      if (duty.ShiftCode === "Holiday") {
        return [255, 165, 0]; // Orange for Holiday
      }
      if (duty.ShiftCode === "Week Off") {
        return [255, 255, 0]; // Yellow for Week Off
      }
      if (duty.ShiftCode === "Absent") {
        return [220, 38, 38]; // Red for Absent
      }

      // Handle RecordType cases
      if (duty.RecordType === "Shift") {
        return [34, 197, 94]; // Green for Shift
      }
      if (duty.RecordType === "Leave") {
        if (
          duty.ShiftCode !== "Week Off" &&
          duty.ShiftCode !== "Absent" &&
          duty.ShiftCode !== "Holiday"
        ) {
          return [59, 130, 246]; // Blue for specific leave conditions
        }
        if (duty.LeaveType === "Absent") {
          return [220, 38, 38]; // Red for Absent
        }
        if (duty.Status === 1) {
          return [220, 252, 231]; // Light green for approved leave
        } else {
          return [254, 226, 226]; // Light red for rejected leave
        }
      }

      return [255, 255, 255]; // Default white for other cases
    };

    // ======================
    // HEADER SECTION
    // ======================
    const drawHeader = () => {
      doc.setDrawColor(150, 150, 150);
      doc.setLineWidth(0.2);

      // Main title with better typography
      doc.setFontSize(20);
      doc.setFont("helvetica", "bold");
      doc.setTextColor(40, 40, 40);
      doc.text(`${companyDetails?.Name}`, margins.left, margins.top - 8);

      // Subtitle with subtle styling
      doc.setFontSize(12);
      doc.setFont("helvetica", "normal");
      doc.setTextColor(80, 80, 80);
      doc.text(
        `Monthly Employee Duty Schedule Report${
          selectedMethodName ? ` - ${selectedMethodName}` : ""
        }`,
        margins.left,
        margins.top - 2
      );

      // Report period with clear labeling
      const formatDate = (dateString) => {
        const date = new Date(dateString);
        return `${date?.getDate().toString().padStart(2, "0")}-${(
          date?.getMonth() + 1
        )
          .toString()
          .padStart(2, "0")}-${date?.getFullYear()}`;
      };
      doc.setFontSize(10);
      doc.setFont("helvetica", "normal");
      doc.text("Report Period:", margins.left, margins.top + 8);
      doc.setFont("helvetica", "bold");
      doc.text(
        `${formatDate(fromDate)} to ${formatDate(toDate)}`,
        margins.left + 30,
        margins.top + 8
      );

      // Generation timestamp
      doc.setFontSize(9);
      const currentDateTime = new Date();
      const formattedDateTime = `${currentDateTime
        ?.getDate()
        .toString()
        .padStart(2, "0")}-${(currentDateTime.getMonth() + 1)
        .toString()
        .padStart(2, "0")}-${currentDateTime.getFullYear()} ${currentDateTime
        .getHours()
        .toString()
        .padStart(2, "0")}:${currentDateTime
        .getMinutes()
        .toString()
        .padStart(2, "0")}`;
      doc.text(
        `Generated: ${formattedDateTime}`,
        pageWidth - margins.right,
        margins.top - 5,
        { align: "right" }
      );

      // Header separator line
      doc.setDrawColor(200, 200, 200);
      doc.setLineWidth(0.5);
      doc.line(
        margins.left,
        margins.top + 12,
        pageWidth - margins.right,
        margins.top + 12
      );
    };

    // ======================
    // TABLE SECTION
    // ======================
    const tableStartY = margins.top + 20;

    // Calculate optimal column widths based on actual date range
    const actualDateCount = Math.min(dates.length, 31);
    const employeeColumnWidth = 50;
    const availableWidthForDates = contentWidth - employeeColumnWidth;

    // Distribute remaining width evenly among actual date columns
    const dateColumnWidth = availableWidthForDates / actualDateCount;

    // Prepare column headers with formatted dates
    const tableColumns = [
      {
        header: "Employee\nName & Code",
        dataKey: "employee",
        styles: {
          halign: "left",
          valign: "middle",
          cellWidth: employeeColumnWidth,
          fontStyle: "bold",
        },
      },
      ...dates.slice(0, 31).map((date) => {
        const dateObj = new Date(date);
        const dayName = dateObj.toLocaleDateString("en-US", {
          weekday: "short",
        });
        const dayNum = dateObj.getDate();

        return {
          header: `${dayName}\n${dayNum}`,
          dataKey: date,
          styles: {
            halign: "center",
            valign: "middle",
            cellWidth: dateColumnWidth,
          },
        };
      }),
    ];

    // Prepare table data using ALL filtered employees
    const tableData = filteredEmployees.map((employee) => {
      const row = {
        employee: `${employee.Name}\nCode: ${employee.Code}`,
      };

      dates.slice(0, 31).forEach((date) => {
        const duty = getDutyForEmployeeAndDate(employee.Id, date);
        if (duty) {
          // Simplified duty representation
          if (duty.RecordType === "Leave") {
            row[date] = `${duty.ShiftCode}`;
          } else if (duty.RecordType === "Holiday") {
            row[date] = "H";
          } else if (duty.ShiftCode) {
            // Truncate long shift codes
            row[date] =
              duty.ShiftCode.length > 4
                ? duty.ShiftCode.substring(0, 4)
                : duty.ShiftCode;
          } else {
            row[date] = "P";
          }
        } else {
          row[date] = "-";
        }
      });
      return row;
    });

    // Split tableData into chunks of 17 employees
    const employeesPerPage = 17;
    const dataChunks = [];
    for (let i = 0; i < tableData.length; i += employeesPerPage) {
      dataChunks.push(tableData.slice(i, i + employeesPerPage));
    }

    // Generate tables for each chunk
    dataChunks.forEach((chunk, index) => {
      if (index > 0) {
        doc.addPage();
      }
      drawHeader();

      // Generate the table with improved styling and colors
      doc.autoTable({
        columns: tableColumns,
        body: chunk,
        startY: tableStartY,
        margin: {
          left: margins.left,
          right: margins.right,
        },
        styles: {
          fontSize: 8,
          cellPadding: { top: 2, right: 1, bottom: 2, left: 1 },
          overflow: "ellipsize",
          lineColor: [180, 180, 180],
          lineWidth: 0.3,
          textColor: [40, 40, 40],
          fillColor: [255, 255, 255],
        },
        headerStyles: {
          fillColor: [255, 255, 255], // White header background
          textColor: [0, 0, 0],
          fontStyle: "bold",
          fontSize: 8,
          cellPadding: { top: 3, right: 1, bottom: 3, left: 1 },
          halign: "center",
          valign: "middle",
          lineColor: [120, 120, 120],
          lineWidth: 0.5,
        },
        columnStyles: {
          0: {
            // Employee column
            cellWidth: employeeColumnWidth,
            fillColor: [255, 255, 255],
            fontStyle: "bold", // Make employee names bold
            halign: "left",
            valign: "middle",
            fontSize: 9, // Slightly larger font for employee names
          },
          // Date columns - dynamically set width for each actual date
          ...dates.slice(0, 31).reduce((acc, date, index) => {
            acc[index + 1] = {
              cellWidth: dateColumnWidth,
              halign: "center",
              valign: "middle",
              fontSize: 7,
            };
            return acc;
          }, {}),
        },
        // Custom cell styling with colors
        didParseCell: (data) => {
          // Only apply colors to data rows (not header rows)
          if (data.row.section === "body" && data.column.index > 0) {
            // Not the employee column and not header
            const date = dates[data.column.index - 1];
            const employee =
              filteredEmployees[data.row.index + index * employeesPerPage];

            if (employee && date) {
              const duty = getDutyForEmployeeAndDate(employee.Id, date);
              // Apply single color for non-split cases
              if (
                duty?.RecordType !== "ShiftAndLeave" &&
                duty?.RecordType !== "Absent+Halfday"
              ) {
                const color = getDutyColor(duty);
                data.cell.styles.fillColor = color;
              }
              // Always use black bold text for all duty cells
              data.cell.styles.textColor = [0, 0, 0]; // Black text
              data.cell.styles.fontStyle = "bold"; // Bold text
            }
          }
        },
        didDrawCell: (data) => {
          // Handle split-color cells for ShiftAndLeave and Absent+Halfday
          if (data.row.section === "body" && data.column.index > 0) {
            const date = dates[data.column.index - 1];
            const employee =
              filteredEmployees[data.row.index + index * employeesPerPage];

            if (employee && date) {
              const duty = getDutyForEmployeeAndDate(employee.Id, date);
              if (duty?.RecordType === "ShiftAndLeave") {
                // Draw split background: green (left) for Shift, blue (right) for Leave
                doc.setFillColor(34, 197, 94); // Green for Shift (#22C55E)
                doc.rect(
                  data.cell.x,
                  data.cell.y,
                  data.cell.width / 2,
                  data.cell.height,
                  "F"
                );
                doc.setFillColor(86, 192, 245); // Light blue for Leave (#56C0F5)
                doc.rect(
                  data.cell.x + data.cell.width / 2,
                  data.cell.y,
                  data.cell.width / 2,
                  data.cell.height,
                  "F"
                );
              } else if (duty?.RecordType === "Absent+Halfday") {
                // Draw split background: red (left) for Absent, light blue (right) for Halfday
                doc.setFillColor(220, 38, 38); // Red for Absent (#DC2626)
                doc.rect(
                  data.cell.x,
                  data.cell.y,
                  data.cell.width / 2,
                  data.cell.height,
                  "F"
                );
                doc.setFillColor(86, 192, 245); // Light blue for Halfday (#56C0F5)
                doc.rect(
                  data.cell.x + data.cell.width / 2,
                  data.cell.y,
                  data.cell.width / 2,
                  data.cell.height,
                  "F"
                );
              }
            }
          }
        },
        didDrawPage: (data) => {
          // Footer with page number
          doc.setFontSize(8);
          doc.setTextColor(120, 120, 120);
          doc.text(`Page ${data.pageNumber}`, pageWidth / 2, pageHeight - 10, {
            align: "center",
          });

          // Footer separator line
          doc.setDrawColor(220, 220, 220);
          doc.setLineWidth(0.3);
          doc.line(
            margins.left,
            pageHeight - 15,
            pageWidth - margins.right,
            pageHeight - 15
          );
        },
      });

      // ======================
      // COLOR LEGEND SECTION
      // ======================
      let legendY = doc.lastAutoTable.finalY + 15;

      // Legend title
      doc.setFontSize(10);
      doc.setFont("helvetica", "bold");
      doc.setTextColor(40, 40, 40);
      doc.text("Legend:", margins.left, legendY);

      // Legend items
      const legendItems = [
        { color: [34, 197, 94], text: "Shift", code: "S" },
        { color: [255, 165, 0], text: "Holiday", code: "H" },
        { color: [255, 255, 0], text: "Week Off", code: "WO" },
        { color: [220, 38, 38], text: "Absent", code: "A" },
        { color: [59, 130, 246], text: "Leave", code: "L" },
      ];

      let legendX = margins.left;
      const legendItemWidth = 35;
      const legendBoxSize = 4;

      legendItems.forEach((item, idx) => {
        const y = legendY + 8;

        // Draw color box (split for ShiftAndLeave and Absent+Halfday)
        if (item.text === "Shift + Leave" || item.text === "Absent + Halfday") {
          // Draw split color box
          doc.setFillColor(item.color[0], item.color[1], item.color[2]); // First color
          doc.rect(legendX, y - 3, legendBoxSize / 2, legendBoxSize, "F");
          doc.setFillColor(item.color[3], item.color[4], item.color[5]); // Second color
          doc.rect(
            legendX + legendBoxSize / 2,
            y - 3,
            legendBoxSize / 2,
            legendBoxSize,
            "F"
          );
        } else {
          // Draw single color box
          doc.setFillColor(item.color[0], item.color[1], item.color[2]);
          doc.rect(legendX, y - 3, legendBoxSize, legendBoxSize, "F");
        }

        // Draw text
        doc.setFontSize(7);
        doc.setFont("helvetica", "normal");
        doc.setTextColor(40, 40, 40);
        doc.text(`${item.text} (${item.code})`, legendX + legendBoxSize + 2, y);

        legendX += legendItemWidth;

        // Move to next line if needed
        if ((idx + 1) % 7 === 0) {
          legendX = margins.left;
          legendY += 8;
        }
      });
    });

    // ======================
    // FOOTER SECTION
    // ======================
    const footerY = pageHeight - 8;

    // Company information
    doc.setFontSize(7);
    doc.setTextColor(100, 100, 100);
    doc.text(
      `${companyDetails?.Name} - Internal Use Only`,
      margins.left,
      footerY
    );

    doc.text(
      `Report generated on ${new Date().toLocaleDateString("en-IN")}`,
      pageWidth - margins.right,
      footerY,
      { align: "right" }
    );

    // Save the PDF with professional filename
    const dateRange = `${fromDate.replace(/\//g, "-")}_to_${toDate.replace(
      /\//g,
      "-"
    )}`;
    doc.save(`${companyDetails?.Name}_Monthly_Duty_Schedule_${dateRange}.pdf`);
  };

  const handleFilterChange = (selectedMethod, selectedOptionId) => {
    let selectedMethodName = "";

    switch (selectedMethod) {
      case "CategoryId":
        selectedMethodName =
          category?.data?.data.find((el) => el.Id === selectedOptionId)?.Name ||
          "";
        break;
      case "ProfitCenterId":
        selectedMethodName =
          FilterProfitcenter?.data?.data.find(
            (el) => el.Id === selectedOptionId
          )?.Name || "";
        break;
      case "GroupId":
        selectedMethodName =
          group?.data?.data.find((el) => el.Id === selectedOptionId)?.Name ||
          "";
        break;
      case "DesignationId":
        selectedMethodName =
          designation?.data?.data.find((el) => el.Id === selectedOptionId)
            ?.Name || "";
        break;
      case "DepartmentId":
        selectedMethodName =
          Department?.find((el) => el.Id === selectedOptionId)?.Name || "";
        break;
      default:
        console.warn("Unknown selected method:", selectedMethod);
    }

    // Set the selected method name and filter method
    setselectedMethodName(selectedMethodName);
    setFilterMethod(selectedMethod);

    // Start with a copy of RecordData
    let filteredData = [...RecordData];

    // Apply filtering based on the selected method
    filteredData = filteredData.filter((item) => {
      switch (selectedMethod) {
        case "DepartmentId":
          return item.DepartmentID === selectedOptionId;
        case "DesignationId":
          return item.DesignationId === selectedOptionId;
        case "ProfitCenterId":
          return item.ProfitCenterID === selectedOptionId;
        case "CategoryId":
          return item.CategoryId === selectedOptionId;
        case "GroupId":
          return item.GroupId === selectedOptionId;
        default:
          return true;
      }
    });

    // Update the state with the filtered data
    setDataFilter(filteredData);
  };

  const groupOptionsByType = (options) => {
    return options.reduce((acc, option) => {
      if (!acc[option.Type]) {
        acc[option.Type] = [];
      }
      acc[option.Type].push(option);
      return acc;
    }, {});
  };

  const handleClearFilter = () => {
    setFilterMethod(""); // Clear the selected filter method
    setDataFilter(RecordData); // Reset to the original unfiltered data
  };

  // Helper function to format date as YYYY-MM-DD
  const formatDate = (date) => {
    return date.toISOString().split("T")[0];
  };
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Move the filtering logic inside useEffect or useMemo to better control when it runs
  const filteredEmployees = useMemo(() => {
    return employeeDetails.filter((employee) => {
      const matchesName = employee.Name.toLowerCase().includes(
        searchTermtable.toLowerCase()
      );
      const matchesCode = employee.Code.toLowerCase().includes(
        searchTermtable.toLowerCase()
      );
      const matchesSelected =
        filterMethod && selectedOptionId
          ? employee[filterMethod] === selectedOptionId
          : true;

      return (matchesName || matchesCode) && matchesSelected;
    });
  }, [employeeDetails, searchTermtable, filterMethod, selectedOptionId]);

  // Move pagination function outside or use useMemo for better performance
  const paginateEmployees = useCallback(
    (employees) => {
      const indexOfLastRow = currentPage * rowsPerPage;
      const indexOfFirstRow = indexOfLastRow - rowsPerPage;
      return employees.slice(indexOfFirstRow, indexOfLastRow);
    },
    [currentPage, rowsPerPage]
  );
  // Get current page employees
  const currentEmployees = useMemo(() => {
    return paginateEmployees(filteredEmployees);
  }, [filteredEmployees, paginateEmployees]);

  const totalPages = Math.ceil(filteredEmployees.length / rowsPerPage);

  // Generate array of dates between 'fromDate' and 'toDate'
  const generateDateRange = (startDate, endDate) => {
    const start = new Date(startDate);
    const end = new Date(endDate);
    const dateArray = [];

    let currentDate = new Date(start);
    while (currentDate <= end) {
      dateArray.push(formatDate(new Date(currentDate)));
      currentDate.setDate(currentDate.getDate() + 1);
    }

    return dateArray;
  };

  // Fetch employee data
  const getEmployeeData = async () => {
    try {
      const response = await getEmployee(UID);
      const data =
        isAdmin == 1
          ? response?.data?.data
          : response?.data?.data.filter((el) => el.DepartmentId == DepId);
      if (data) {
        setEmployeeDetails(data);
        setShiftEmployeeData(data);
      } else {
        console.warn("Employee data is empty or undefined.");
      }
    } catch (error) {
      console.error("Error fetching employee details:", error);
    }
  };

  // Fetch shift data - You'll need to create this function based on your API
  const fetchShiftData = async () => {
    try {
      // Replace with your actual shift data fetching method
      const response = await getShift(UID); // Assuming you have this function
      if (response?.data?.data) {
        setShiftData(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching shift data:", error);
    }
  };

  //   ========oggg

  const fetchrecordsforautherise = async (from = fromDate, to = toDate) => {
    const Data = {
      FromDate: formatDate(new Date(from)),
      ToDate: formatDate(new Date(to)),
    };
    try {
      const response = await getRecordsForAutherise(Data);
      if (response?.data?.data) {
        setRecordData(response.data.data);
        setDates(generateDateRange(Data.FromDate, Data.ToDate));
      }
    } catch (error) {
      console.error("Error fetching records:", error);
    }
  };

  const fetgetAutheriseOptions = async () => {
    try {
      const response = await getAutheriseOptions(isAdmin, DepId); // pass both
      if (response?.data?.data) {
        setTemp(response.data.data);
      }
    } catch (error) {
      console.error("Error options data:", error);
    }
  };

  // Fetch duty allocation data
  const fetchDuties = async () => {
    setLoading(true);
    const data = {
      Date: fromDate,
      ToDate: toDate,
      UserId: UID,
    };

    try {
      const response = await getdutywithdate(data);
      let details = response?.data?.data || [];

      // Filter by department if not admin
      if (isAdmin != 1) {
        details = details.filter((el) => el?.DepartmentID === DepId);
      }

      setDutyData(details);
      setDates(generateDateRange(fromDate, toDate));
    } catch (error) {
      console.error("Error fetching duty data", error);
    } finally {
      setLoading(false);
    }
  };
  const handleShowClick = async () => {
    setLoading(true);
    try {
      await fetchrecordsforautherise(fromDate, toDate);
      await fetchDuties(fromDate, toDate);
      await fetgetAutheriseOptions();
    } finally {
      setLoading(false);
    }
  };

  // Get duty for a specific employee and date
  const getDutyForEmployeeAndDate = (employeeId, date) => {
    const duty = RecordData.find(
      (d) =>
        d.EMPLOYEEID === employeeId &&
        formatDate(new Date(d.RECORDDATE)) === date
    );

    return duty;
  };

  //   oggg==================
  const handleCellClick = (employee, date) => {
    const department = employee?.DepartmentName?.toLowerCase();
    const isITI = department?.includes("iti");

    const filteredShift = isITI
      ? temp.filter((el) => !el.Name?.toLowerCase().includes("week")) // ITI: Remove any shift containing "week"
      : temp.filter((el) => !el.Name?.toLowerCase().includes("holiday")); // Others: Remove any shift containing "holiday"

    setOptions(filteredShift);

    // Toggle dropdown
    const dropdownId = `${employee.Id}-${date}`;
    setActiveDropdown(activeDropdown === dropdownId ? null : dropdownId);
  };

  //   oggg======================
  const getCellBackgroundColor = (duty) => {
    if (!duty) return ""; // No duty, no background color

    // Handle specific ShiftCode cases
    if (duty.ShiftCode === "Holiday") {
      return "bg-orange-500"; // Holiday color
    }
    if (duty.ShiftCode === "Week Off") {
      return "bg-yellow"; // Week Off color
    }
    if (duty.ShiftCode === "Absent") {
      return "bg-red-600"; // Absent color
    }

    // // Handle RecordType cases
    // if (duty.RecordType === "ShiftAndLeave") {
    //   return "bg-[#fc03fc]"; // ✅ correct
    // }

    // // Handle RecordType cases
    // if (duty.RecordType === "Absent+Halfday") {
    //   return "bg-[#f7cdcd]"; // ✅ correct
    // }

    if (duty.RecordType === "Shift") {
      return "bg-green-500"; // Shift color
    }

    if (duty.RecordType === "Leave") {
      if (
        duty.ShiftCode !== "Week Off" &&
        duty.ShiftCode !== "Absent" &&
        duty.ShiftCode !== "Holiday"
      ) {
        return "bg-blue"; // Custom color for specific leave conditions
      }
      if (duty.LeaveType === "Absent") {
        return "bg-red-600"; // Darker red for Absent
      }
      if (duty.Status === 1) {
        return "bg-green-100"; // Approved leave
      } else {
        return "bg-red-100"; // Rejected leave or other cases
      }
    }

    return ""; // Default case with no background
  };

  const handleOptionSelect = async (employee, date, option, duty) => {
    try {
      if (option?.Name === "Weekly Off") {
        if (duty?.RecordType === "Leave" || duty === undefined) {
          const Payload = {
            LeaveId: duty?.ID || null,
            EmpId: employee.Id,
            RECORDDATE: duty?.RECORDDATE || date,
            UserId: UID,
            Option: option.Id,
          };

          try {
            const response = await UpdateLeaveandInsertRecord(Payload);
            if (response) fetchrecordsforautherise();
          } catch (err) {
            console.error("Error in UpdateLeaveandInsertRecord:", err);
          }
        } else if (duty?.RecordType === "Shift") {
          const Payload = {
            RecordID: duty?.ID,
            EmpId: employee.Id,
            RECORDDATE: duty.RECORDDATE,
            UserId: UID,
            Option: option.Id,
          };

          try {
            const response = await UpdaterecordandInsertRecord(Payload);
            if (response) fetchrecordsforautherise();
          } catch (err) {
            console.error("Error in UpdaterecordandInsertRecord:", err);
          }
        }
      } else if (option?.Type === "Shift") {
        const Payload = {
          ShiftId: option.Id,
          ID: duty?.ID,
          RecordType: duty?.RecordType,
          EMPLOYEEID: employee.Id,
          date: date,
          UserId: UID,
        };

        try {
          const response = await UpdateRecordsFromAutherise(Payload);
          if (response) fetchrecordsforautherise();
        } catch (err) {
          console.error("Error in UpdateRecordsFromAutherise:", err);
        }
      } else if (option?.Type === "Leave") {
        if (duty?.RecordType === "Leave") {
          const Payload = {
            Id: duty.ID,
            LeaveType: option.Id,
          };

          try {
            const response = await UpdateAutheriseLeavetoLeave(Payload);
            if (response) fetchrecordsforautherise();
          } catch (err) {
            console.error("Error in UpdateAutheriseLeavetoLeave:", err);
          }
        } else {
          const Payload = {
            RecordID: duty?.ID,
            LeaveTypeId: option.Id,
            EmployeeId: employee.Id,
            LeaveDate: date,
          };

          try {
            const response = await UpdateRecordsandleaveFromAutherise(Payload);

            const isSuccess = response?.data?.data?.success;
            if (response?.status === 201 && isSuccess) {
              toast.success("Updated successfully");
              fetchrecordsforautherise();
            } else {
              const errorMsg = response?.data?.data?.error || "Update failed";
              toast.error(errorMsg);
            }
          } catch (error) {
            console.error(
              "API error in UpdateRecordsandleaveFromAutherise:",
              error
            );
            const errorMsg =
              error?.response?.data?.data?.error ||
              error?.message ||
              "Something went wrong while updating";
            toast.error(errorMsg);
          }
        }
      }
    } catch (outerErr) {
      console.error("Unexpected error in handleOptionSelect:", outerErr);
    }

    // Close the dropdown
    setActiveDropdown(null);
  };

  const handleopenModal = () => {
    setModalOpen(true);
  };
  const Modalback = () => {
    setModalOpen(false);
  };

  const handleopenModalColor = () => {
    setModalOpenClr(true);
  };
  const ModalbackColor = () => {
    setModalOpenClr(false);
  };

  useEffect(() => {
    const fetchGroup = async () => {
      try {
        const response = await getGroup(UID);

        setGroup(response);
      } catch (error) {
        console.error("Error fetching cate:", error);
      }
    };

    fetchGroup();
  }, []);

  useEffect(() => {
    const fetchfilterProfitecenter = async () => {
      try {
        const response = await getProfitCenter(UID);
        setFilterProfitcenter(response);
      } catch (error) {
        console.error("Error fetching cate:", error);
      }
    };
    fetchfilterProfitecenter();
  }, [UID]);

  useEffect(() => {
    setDataFilter(RecordData);
  }, [RecordData]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setActiveDropdown(null);
      }
    }

    if (activeDropdown) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [activeDropdown]);

  useEffect(() => {
    setCurrentPage(1); // Reset to first page when filtering changes
  }, [searchTermtable, filterMethod, selectedOptionId]);

  useEffect(() => {
    const today = new Date();
    const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 2); // First day of current month

    setToDate(formatDate(today));
    setFromDate(formatDate(startOfMonth));

    // Fetch initial data without loading state
    fetchrecordsforautherise(startOfMonth, today);
    fetgetAutheriseOptions();
    fetchDuties();
  }, []);

  useEffect(() => {
    getEmployeeData();
    fetchShiftData();
  }, [UID]);

  useEffect(() => {
    const fetchEmpLeaveData = async () => {
      const UserId = UID;
      try {
        const response = await ProcessEmpLeaveALL(UserId);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching profit centers:", error);
      }
    };
    fetchEmpLeaveData();
  }, []);

  useEffect(() => {
    const fetchProfitCenters = async () => {
      try {
        const responses = await getDepartments(UID);

        setDepartment(responses.data.data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching profit centers:", error);
      }
    };
    fetchProfitCenters();
  }, []);

  useEffect(() => {
    const dataMapping = {
      CategoryId: category?.data?.data,
      ProfitCenterId: FilterProfitcenter?.data?.data,
      GroupId: group?.data?.data,
      DesignationId: designation?.data?.data,
      DepartmentId: Department,
    };
    setDropdownOptions(dataMapping[filterMethod] || []);
  }, [
    filterMethod,
    category,
    FilterProfitcenter,
    group,
    designation,
    Department,
  ]);

  useEffect(() => {
    fetchCompanyDetails();
  }, []);

  useEffect(() => {
    const today = new Date();
    // Get the first day of the current month
    const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 2);

    // Set the date states
    setToDate(formatDate(today)); // Set 'toDate' to today's date
    setFromDate(formatDate(startOfMonth)); // Set 'fromDate' to the first day of the current month
  }, []);
  useEffect(() => {
    if (searchTerm === "") {
      setFilteredOptions(options);
    } else {
      const filtered = options.filter(
        (option) =>
          option.Name.toLowerCase().includes(searchTerm.toLowerCase()) ||
          option.Type.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredOptions(filtered);
    }
  }, [searchTerm, options]);

  useEffect(() => {
    const fetchcategory = async () => {
      try {
        const response = await getCategorys(UID);

        setCategory(response);
      } catch (error) {
        console.error("Error fetching cate:", error);
      }
    };

    fetchcategory();
  }, []);

  return (
    <div className="container mx-auto p-4 flex flex-col gap-4">
      {moadaopenClr && (
        <div className="fixed inset-0 flex justify-center items-center bg-opacity-60 backdrop-blur-sm z-[1000]">
          <div className="p-8 rounded-xl shadow-xl bg-white w-[700px] max-h-[550px] flex flex-col">
            <div className="flex justify-between items-center border-b pb-3 mb-4">
              <h2 className="text-2xl font-semibold text-gray-800">
                Color Codes
              </h2>
            </div>
            <div className="flex-grow overflow-y-auto max-h-[450px] pr-4">
              <div className="space-y-4">
                <div className="flex items-center p-3 rounded-lg border border-gray-200 bg-white hover:bg-gray-50">
                  <div className="w-8 h-8 rounded-full bg-orange-500 mr-4"></div>
                  <div>
                    <p className="font-medium">Holiday</p>
                    <p className="text-sm text-gray-500">
                      Indicates employees on a holiday.
                    </p>
                  </div>
                </div>

                <div className="flex items-center p-3 rounded-lg border border-gray-200 bg-white hover:bg-gray-50">
                  <div className="w-8 h-8 rounded-full bg-yellow mr-4"></div>
                  <div>
                    <p className="font-medium">Week Off</p>
                    <p className="text-sm text-gray-500">
                      Employees who are off for the week.
                    </p>
                  </div>
                </div>

                <div className="flex items-center p-3 rounded-lg border border-gray-200 bg-white hover:bg-gray-50">
                  <div className="w-8 h-8 rounded-full bg-red-600 mr-4"></div>
                  <div>
                    <p className="font-medium">Absent</p>
                    <p className="text-sm text-gray-500">
                      Employees who are absent.
                    </p>
                  </div>
                </div>

                <div className="flex items-center p-3 rounded-lg border border-gray-200 bg-white hover:bg-gray-50">
                  <div className="w-8 h-8 rounded-full bg-green-500 mr-4"></div>
                  <div>
                    <p className="font-medium">Shift</p>
                    <p className="text-sm text-gray-500">
                      Employees on a scheduled shift.
                    </p>
                  </div>
                </div>

                <div className="flex items-center p-3 rounded-lg border border-gray-200 bg-white hover:bg-gray-50">
                  <div className="w-8 h-8 rounded-full bg-green-100 mr-4"></div>
                  <div>
                    <p className="font-medium">Approved Leave</p>
                    <p className="text-sm text-gray-500">
                      Employees with approved leaves.
                    </p>
                  </div>
                </div>
                {/* <div className="flex items-center p-3 rounded-lg border border-gray-200 bg-white hover:bg-gray-50">
                  <div className="w-8 h-8 rounded-full bg-[#fc03fc] mr-4"></div>
                  <div>
                    <p className="font-medium">Approved Halfday+shift</p>
                    <p className="text-sm text-gray-500">
                      Employees with HalfDay and shift.
                    </p>
                  </div>
                </div> */}

                {/* <div className="flex items-center p-3 rounded-lg border border-gray-200 bg-white hover:bg-gray-50">
                  <div className="w-8 h-8 rounded-full bg-[#f7cdcd] mr-4"></div>
                  <div>
                    <p className="font-medium">Halfday+Absent</p>
                    <p className="text-sm text-gray-500">
                      Employees with HalfDay and Absent.
                    </p>
                  </div>
                </div> */}
              </div>
            </div>
            <div className="flex justify-end mt-6">
              <button
                className="px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-400 transition"
                onClick={ModalbackColor}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="flex items-center gap-4">
        <Breadcrumb title="Authorize section" />
        <p className="text-gray-800 bg-gray-100 border border-gray-300 p-4 rounded-md font-sans text-sm leading-relaxed">
          <strong className="text-red-600">Note:</strong> This is an approval
          page. You cannot approve duties for current and future dates, can
          approve only for previous dates. You can approve leave, weekly off and
          absent on all dates. Any action taken on this page will be directly
          approved.
        </p>
        <button className="btn btn-primary" onClick={handleopenModal}>
          Show Info
        </button>
        <button
          className="btn btn-danger"
          onClick={() => generatePDF(selectedMethodName)}
        >
          Download PDF
        </button>
      </div>

      {moadaopen && (
        <div className="w-[700px] h-[200px] overflow-y-scroll bg-white border border-gray-300 rounded-lg p-2 flex flex-col">
          <div className="flex-grow overflow-y-auto max-h-[500px]">
            <p className="text-center">Shift Code</p>
            <br />
            {[
              ...new Map(
                RecordData.filter(
                  (el) => el.RecordType === "Shift" && el.ShiftName !== null
                ).map((el) => [el.ShiftName, el])
              ).values(),
            ].map((el, index) => (
              <p key={index} className="text-lg font-medium">
                {`${el.ShiftName}: (${el.ShiftCode})`}
              </p>
            ))}
          </div>

          <div className="flex justify-end mt-2">
            <button className="btn btn-danger" onClick={Modalback}>
              Close
            </button>
          </div>
        </div>
      )}

      {moadaopen && (
        <div className="fixed inset-0 flex justify-center items-center  bg-opacity-50 backdrop-blur-sm z-[1000]">
          <div className="p-8 rounded-xl shadow-xl bg-white w-[700px] max-h-[550px] flex flex-col">
            <div className="flex-grow overflow-y-scroll max-h-[450px] pr-4">
              <h2 className="text-2xl font-semibold text-center text-gray-800 mb-4">
                Shift Codes
              </h2>
              {[
                ...new Map(
                  RecordData.filter(
                    (el) => el.RecordType === "Shift" && el.ShiftName !== null
                  ).map((el) => [el.ShiftName, el])
                ).values(),
              ].map((el, index) => (
                <div
                  key={index}
                  className="flex justify-between items-center py-2 border-b border-gray-200"
                >
                  <p className="text-lg font-medium text-gray-700">
                    {el.ShiftName}
                  </p>
                  <p className="text-lg text-gray-500">({el.ShiftCode})</p>
                </div>
              ))}
            </div>
            <div className="flex justify-end mt-6">
              <button
                className="px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-400 transition"
                onClick={Modalback}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
      <div className="mb-6">
        <div className="flex flex-wrap items-center gap-3 w-full">
          {/* Date Inputs */}
          <div className="flex items-center gap-2">
            <label
              htmlFor="fromDate"
              className="whitespace-nowrap text-sm font-medium"
            >
              From Date:
            </label>
            <input
              type="date"
              id="fromDate"
              className="border px-2 py-1 rounded text-sm w-[130px]"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
            />
          </div>

          <div className="flex items-center gap-2">
            <label
              htmlFor="toDate"
              className="whitespace-nowrap text-sm font-medium"
            >
              To Date:
            </label>
            <input
              type="date"
              id="toDate"
              className="border px-2 py-1 rounded text-sm w-[130px]"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
            />
          </div>

          {/* Show Button */}
          <button
            className="btn btn-success px-3 py-1 whitespace-nowrap text-sm"
            onClick={handleShowClick}
          >
            Show
          </button>

          {/* Search Input */}
          <input
            type="text"
            placeholder="Search by name or code"
            className="p-2 border border-gray-300 rounded text-sm flex-1 min-w-[180px] max-w-[250px]"
            value={searchTermtable}
            onChange={(e) => setSearchTermtable(e.target.value)}
          />

          {/* Filter Method Select */}
          <select
            id="filter-method"
            name="filter-method"
            className="w-[160px] px-2 py-2 border border-gray-400 rounded-md focus:outline-none focus:ring-0 focus:border-gray-600 text-sm"
            value={filterMethod}
            onChange={(e) => setFilterMethod(e.target.value)}
          >
            <option value="">Filter By</option>
            <option value="CategoryId">Category</option>
            <option value="ProfitCenterId">Profit Center</option>
            <option value="GroupId">Group</option>
            <option value="DesignationId">Designation</option>
            {isAdmin == 1 && <option value="DepartmentId">Department</option>}
          </select>

          {/* Dynamic Options Select */}
          <select
            id="dynamic-options"
            name="dynamic-options"
            className="w-[160px] px-2 py-2 border border-gray-400 rounded-md focus:outline-none focus:ring-0 focus:border-gray-600 text-sm"
            onChange={(e) => {
              const selectedOptionId = e.target.value;
              if (selectedOptionId) {
                handleFilterChange(filterMethod, selectedOptionId);
              }
              setselectedOptionId(e.target.value);
            }}
          >
            <option value="">Choose One</option>
            {dropdownOptions?.length > 0 &&
              dropdownOptions?.map((option) => (
                <option key={option.Id} value={option.Id}>
                  {option.Name}
                </option>
              ))}
          </select>

          {/* Action Buttons */}
          <button
            onClick={handleClearFilter}
            className="px-3 py-2 bg-red-500 text-white rounded-md btn btn-danger whitespace-nowrap text-sm"
          >
            Clear
          </button>

          <button
            onClick={handleopenModalColor}
            className="btn btn-success px-3 py-2 whitespace-nowrap text-sm"
          >
            Show Color Info
          </button>
        </div>
      </div>
      {/* <button className="btn btn-primary mb-2 " onClick={openAddCategoryModal}>Assign Duty Within a Date Range</button> */}

      {loading && !editCategoryModal && !addCategoryModal ? (
        <div className="fixed inset-0 flex justify-center items-center  bg-opacity-30 z-[1000]">
          <div className="bg-transparent p-6 rounded-lg shadow-md flex justify-center items-center w-48 h-48">
            <div className="w-16 h-16 border-t-4 border-blue-500 border-solid rounded-full animate-spin"></div>
          </div>
        </div>
      ) : (
        <div className="w-full h-[500px] overflow-scroll">
          <table className="min-w-full border border-gray-300">
            <thead>
              <tr className="bg-gray-100">
                <th className="border border-gray-300 px-4 py-2 sticky left-0 bg-gray-100 z-20">
                  Employee
                </th>
                {dates?.map((date, index) => (
                  <th
                    key={index}
                    className="border border-gray-300 px-4 py-2 text-center"
                  >
                    {new Date(date).toLocaleDateString("en-US", {
                      month: "short",
                      day: "numeric",
                    })}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {currentEmployees?.map((employee) => (
                <tr key={employee.Id}>
                  <td className="border border-gray-300 px-4 py-2 sticky left-0 bg-white z-20 font-medium">
                    {employee.Name} ({employee.Code})
                  </td>
                  {dates.map((date, index) => {
                    const duty = getDutyForEmployeeAndDate(employee.Id, date);
                    const dropdownId = `${employee.Id}-${date}`;
                    const isActive = activeDropdown === dropdownId;

                    return (
                      <td
                        key={index}
                        className={`border border-gray-300 px-4 py-2 text-center cursor-pointer relative ${
                          duty?.RecordType === "Leave" && duty?.Status === 1
                            ? "opacity-50 "
                            : ""
                        }`}
                        onClick={() => {
                          if (
                            !(
                              duty?.RecordType === "Leave" ||
                              (duty?.RecordType === "Absent+Halfday" &&
                                duty?.Status === 1)
                            )
                          ) {
                            handleCellClick(employee, date);
                          }
                        }}
                      >
                        {/* Split background handling */}
                        {duty?.RecordType === "Absent+Halfday" ? (
                          <div className="flex h-full w-full absolute inset-0">
                            <div className="w-1/2 bg-red-400"></div>{" "}
                            {/* Absent */}
                            <div className="w-1/2 bg-[#56c0f5]"></div>{" "}
                            {/* Halfday */}
                          </div>
                        ) : duty?.RecordType === "ShiftAndLeave" ? (
                          <div className="flex h-full w-full absolute inset-0">
                            <div className="w-1/2 bg-green-500"></div>{" "}
                            {/* Shift */}
                            <div className="w-1/2 bg-[#56c0f5]"></div>{" "}
                            {/* Leave */}
                          </div>
                        ) : duty?.RecordType === "Unapproved+Halfday" ? (
                          <div className="flex h-full w-full absolute inset-0">
                            <div className="w-1/2 bg-white"></div>{" "}
                            {/* Unapproved */}
                            <div className="w-1/2 bg-[#56c0f5]"></div>{" "}
                            {/* Halfday */}
                          </div>
                        ) : (
                          <div
                            className={`absolute inset-0 ${getCellBackgroundColor(
                              duty
                            )}`}
                          />
                        )}

                        {/* Cell content stays on top */}
                        <div className="relative flex items-center justify-center z-10">
                          <span>
                            {duty ? (
                              duty.RecordType === "Shift" &&
                              duty.ShiftCode !== "Week Off" ? (
                                <span className="font-bold">
                                  {duty.ShiftCode}
                                </span>
                              ) : (
                                <span className="fs-2 font-bold">
                                  {duty.ShiftCode}
                                </span>
                              )
                            ) : (
                              "-"
                            )}
                          </span>
                          <IconChevronDown size={16} className="ml-1" />
                        </div>

                        {isActive && (
                          <div className="fixed inset-0 flex items-center justify-center z-50 bg-opacity-50 backdrop-blur-sm">
                            <div
                              ref={dropdownRef}
                              className="w-[450px] flex ml-[400px] mt-[500px] bg-white shadow-lg rounded-md border border-gray-200 max-h-[400px] overflow-scroll flex flex-col"
                              style={{
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                              }}
                              onClick={(e) => e.stopPropagation()}
                            >
                              {/* Search Input - Fixed at Top */}
                              <div className="sticky top-0 p-2 border-b border-gray-200 bg-white">
                                <div className="relative">
                                  <input
                                    type="text"
                                    placeholder="Search options..."
                                    value={searchTerm}
                                    onChange={(e) =>
                                      setSearchTerm(e.target.value)
                                    }
                                    className="w-full px-3 py-2 pl-8 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    autoFocus
                                  />
                                  <svg
                                    className="absolute left-2 top-2.5 h-4 w-4 text-gray-400"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeWidth={2}
                                      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                                    />
                                  </svg>
                                  {searchTerm && (
                                    <button
                                      className="absolute right-2 top-2.5"
                                      onClick={() => setSearchTerm("")}
                                    >
                                      <svg
                                        className="h-4 w-4 text-gray-400"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                      >
                                        <path
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          strokeWidth={2}
                                          d="M6 18L18 6M6 6l12 12"
                                        />
                                      </svg>
                                    </button>
                                  )}
                                </div>
                              </div>

                              {/* Options List - Scrollable */}
                              <div className="overflow-y-auto flex-grow">
                                {searchTerm === "" ? (
                                  // Show grouped options when no search is active
                                  Object.entries(
                                    groupOptionsByType(options)
                                  ).map(([type, typeOptions]) => {
                                    // Skip rendering Shift options for current or future dates
                                    const currentDate = new Date();
                                    const selectedDate = new Date(date);
                                    if (
                                      type === "Shift" &&
                                      selectedDate >=
                                        new Date(
                                          currentDate
                                            .toISOString()
                                            .split("T")[0]
                                        )
                                    ) {
                                      return null;
                                    }

                                    return (
                                      <div key={type}>
                                        <div className="sticky top-0 px-4 py-1 bg-gray-100 font-semibold text-sm text-gray-700">
                                          ADD {type} ON {date}
                                        </div>
                                        {typeOptions.map((option) => (
                                          <div
                                            key={`${option.Id}-${option.Type}`}
                                            className={`px-4 py-2 text-left cursor-pointer hover:bg-${
                                              option.Type === "Leave"
                                                ? "red-100"
                                                : "blue-100"
                                            } flex justify-between items-center`}
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              handleOptionSelect(
                                                employee,
                                                date,
                                                option,
                                                duty
                                              );
                                              setActiveDropdown(null);
                                              setSearchTerm("");
                                            }}
                                          >
                                            <span className="font-medium truncate">
                                              {option.Name}
                                            </span>
                                            <span className="text-xs text-gray-500 ml-2 flex-shrink-0">
                                              {option.Type}
                                            </span>
                                          </div>
                                        ))}
                                      </div>
                                    );
                                  })
                                ) : filteredOptions.length > 0 ? (
                                  // Show search results, excluding Shift options for current/future dates
                                  filteredOptions
                                    .filter((option) => {
                                      const currentDate = new Date();
                                      const selectedDate = new Date(date);
                                      return !(
                                        option.Type === "Shift" &&
                                        selectedDate >=
                                          new Date(
                                            currentDate
                                              .toISOString()
                                              .split("T")[0]
                                          )
                                      );
                                    })
                                    .map((option) => (
                                      <div
                                        key={`${option.Id}-${option.Type}`}
                                        className={`px-4 py-2 text-left cursor-pointer hover:bg-${
                                          option.Type === "Leave"
                                            ? "red-100"
                                            : "blue-100"
                                        } flex justify-between items-center`}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleOptionSelect(
                                            employee,
                                            date,
                                            option,
                                            duty
                                          );
                                          setActiveDropdown(null);
                                          setSearchTerm("");
                                        }}
                                      >
                                        <span className="font-medium truncate">
                                          {option.Name}
                                        </span>
                                        <span className="text-xs text-gray-500 ml-2 flex-shrink-0">
                                          {option.Type}
                                        </span>
                                      </div>
                                    ))
                                ) : (
                                  <div className="px-4 py-3 text-center text-gray-500">
                                    No options found
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <div className="flex items-center justify-between border-t border-gray-200 bg-white px-4 py-3 sm:px-6 mt-4">
        <div className="flex flex-1 justify-between sm:hidden">
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
            className={`relative inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium ${
              currentPage === 1
                ? "text-gray-300"
                : "text-gray-700 hover:bg-gray-50"
            }`}
          >
            Previous
          </button>
          <button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            className={`relative ml-3 inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium ${
              currentPage === totalPages
                ? "text-gray-300"
                : "text-gray-700 hover:bg-gray-50"
            }`}
          >
            Next
          </button>
        </div>
        <div className="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between">
          <div>
            <p className="text-sm text-gray-700">
              Showing{" "}
              <span className="font-medium">
                {(currentPage - 1) * rowsPerPage + 1}
              </span>{" "}
              to{" "}
              <span className="font-medium">
                {Math.min(
                  currentPage * rowsPerPage,
                  filteredEmployees?.length // Changed from employeeDetails.length
                )}
              </span>{" "}
              of <span className="font-medium">{filteredEmployees.length}</span>{" "}
            </p>
          </div>
          <div>
            <div className="isolate inline-flex -space-x-px rounded-md shadow-sm">
              <button
                onClick={() => handlePageChange(1)}
                disabled={currentPage === 1}
                className={`relative inline-flex items-center rounded-l-md px-2 py-2 ${
                  currentPage === 1
                    ? "text-gray-300"
                    : "text-gray-500 hover:bg-gray-50"
                }`}
              >
                <span className="sr-only">First</span>
                <svg
                  className="h-5 w-5"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                    clipRule="evenodd"
                  />
                  <path
                    fillRule="evenodd"
                    d="M8.707 5.293a1 1 0 010 1.414L5.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
              </button>
              <button
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
                className={`relative inline-flex items-center px-2 py-2 ${
                  currentPage === 1
                    ? "text-gray-300"
                    : "text-gray-500 hover:bg-gray-50"
                }`}
              >
                <span className="sr-only">Previous</span>
                <svg
                  className="h-5 w-5"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
              </button>

              {/* Page Number Buttons */}
              {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                // Calculate which page numbers to show
                let pageNum;
                if (totalPages <= 5) {
                  pageNum = i + 1;
                } else if (currentPage <= 3) {
                  pageNum = i + 1;
                } else if (currentPage >= totalPages - 2) {
                  pageNum = totalPages - 4 + i;
                } else {
                  pageNum = currentPage - 2 + i;
                }

                return (
                  <button
                    key={pageNum}
                    onClick={() => handlePageChange(pageNum)}
                    className={`relative inline-flex items-center px-4 py-2 text-sm font-semibold ${
                      currentPage === pageNum
                        ? "z-10 bg-blue-600 text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
                        : "text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:outline-offset-0"
                    }`}
                  >
                    {pageNum}
                  </button>
                );
              })}

              <button
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
                className={`relative inline-flex items-center px-2 py-2 ${
                  currentPage === totalPages
                    ? "text-gray-300"
                    : "text-gray-500 hover:bg-gray-50"
                }`}
              >
                <span className="sr-only">Next</span>
                <svg
                  className="h-5 w-5"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
              </button>
              <button
                onClick={() => handlePageChange(totalPages)}
                disabled={currentPage === totalPages}
                className={`relative inline-flex items-center rounded-r-md px-2 py-2 ${
                  currentPage === totalPages
                    ? "text-gray-300"
                    : "text-gray-500 hover:bg-gray-50"
                }`}
              >
                <span className="sr-only">Last</span>
                <svg
                  className="h-5 w-5"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                    clipRule="evenodd"
                  />
                  <path
                    fillRule="evenodd"
                    d="M11.293 14.707a1 1 0 010-1.414L14.586 10l-3.293-3.293a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>

        {/* Rows per page selector */}
        <div className="ml-4 flex items-center">
          <label htmlFor="rowsPerPage" className="mr-2 text-sm text-gray-700">
            Rows per page:
          </label>
          <select
            id="rowsPerPage"
            value={rowsPerPage}
            onChange={(e) => {
              setRowsPerPage(Number(e.target.value));
              setCurrentPage(1); // Reset to first page when changing rows per page
            }}
            className="rounded border border-gray-300 py-1 px-2 text-sm"
          >
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={50}>50</option>
          </select>
        </div>
      </div>
    </div>
  );
}

export default Autherise;
